import { documentsService } from 'hq/services';
import { DateTime } from 'luxon';
import { useMutation, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { DocumentType } from '../documents-page/table/documents-table.types';

export type CreateDocumentParams = {
  flexWorkerId: string;
  startDate: DateTime;
  endDate: DateTime | null;
  documentType: DocumentType;
};

export const useAddDocument = () => {
  const mutationFn = async ({
    flexWorkerId,
    startDate,
    endDate,
    documentType,
  }: CreateDocumentParams) => {
    return await documentsService.createDocument({
      flexWorkerId,
      startDate,
      endDate,
      documentType,
    });
  };

  const queryClient = useQueryClient();

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.documents());
    },
  });
};
